import {Component, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import {ICellEditorAngularComp} from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-dropdown-editor',
    template: `<irb-dropdown #dropdown [options]="params.values" [value]="value" (selection)="onChange($event)"></irb-dropdown>`,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DropdownEditorComponent implements ICellEditorAngularComp {
    params: any;
    value: any;
    cbFunc: Function;

    @ViewChild('dropdown') dropdown: any;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.defaultValue;
        const defaultFunc = this.params.context.componentParent.updateRow?.bind(this.params.context.componentParent) || null;
        this.cbFunc = this.params.onUpdate || defaultFunc;

        for(let i = 0; i < this.params.values.length; i++) {
            if(this.params.values[i][this.params.identifier] === this.params.value) {
                this.value = this.params.values[i];
                break;
            }
        }
    }

    getValue(): any {
        window.setTimeout(() => {
            if(this.cbFunc) {
                this.cbFunc(this.params);
            } 
        },0); 

        return this.value && this.value.id ? this.value.id : null;
    }

    onChange(newValue: any) {
        this.value = newValue;
        this.params.api.stopEditing();
    }

    isPopup() {
        return true;
    }
}
